module.exports = __webpack_public_path__ + "img/美妆-8.42f1a979.png";